import { ReactElement, useEffect } from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import GratiPageWrapper from "../components/common/GratiPageWrapper";
import { useApp } from "../contextProviders/AppProvider";

export default function CopyrightPage(): ReactElement {
  const { setPageName, updateActions } = useApp();

  useEffect(() => {
    setPageName("Gratisports Copyright Policy");
    updateActions([]);
  }, [setPageName, updateActions]);

  return (
    <GratiPageWrapper isAuthRequired={false} isNoAuthRequired={false}>
      <Container maxWidth="md">
        <Typography variant="bodySmall" gutterBottom sx={{
          color: "text.secondary"
        }}>
          Last updated: December 15, 2025
        </Typography>

        <Box>
          <Typography component="p" variant="bodyMedium">
            To report claims of copyright infringement or for questions about
            this Copyright Policy, please contact us at:{" "}
            <Link href="mailto:policy@gratisports.com">
              policy@gratisports.com
            </Link>
          </Typography>
        </Box>
      </Container>
    </GratiPageWrapper>
  );
}
